// Display content for the AI Masterclass page.
// Prices and the deadline are enforced by the backend (backend/config/masterclass.js) — keep them in sync.

// Local runs (`npm start`) use frontend/.env.development.local; production builds use Render.
export const BASE_URL = process.env.REACT_APP_API_URL || "https://bootcamp-registration.onrender.com";

export const SUPPORT_EMAIL = "innovatetoimpactglobal@gmail.com";

// Day 1 kickoff, Fri Nov 20, 2026, 6 PM WAT.
export const REGISTRATION_DEADLINE = new Date("2026-11-20T17:00:00Z");

export const SESSIONS = [
  { day: "Day 1", date: "Friday, Nov 20", time: "6 PM – 9 PM WAT" },
  { day: "Day 2", date: "Saturday, Nov 21", time: "12 PM – 3 PM WAT" },
];

export const TRACKS = [
  {
    id: "automation",
    name: "AI & Automation",
    short: "Workflow building & tools",
    blurb: "Build automated workflows, connect tools, and save operational hours.",
    icon: "⚙️",
  },
  {
    id: "coding",
    name: "AI Assisted Coding",
    short: "Write software with AI copilots",
    blurb: "Use AI copilots to write and ship software faster.",
    icon: "💻",
  },
  {
    id: "content",
    name: "AI Content Creation",
    short: "Effortless video scripting & generation",
    blurb: "Master AI tools to script, generate, and edit high-impact videos.",
    icon: "🎬",
  },
];

export const PACKAGES = [
  {
    id: "live",
    name: "Live Access Only",
    amountKobo: 15000 * 100,
    blurb: "Full entry to both live days, interactive breakout sessions, and live networking.",
  },
  {
    id: "live_recording",
    name: "Live Access + Lifetime Recording",
    amountKobo: 25000 * 100,
    blurb: "Everything in Live Access, plus lifetime replay access to rewatch, pause, and practise at your own pace.",
    highlight: true,
  },
];

export const BENEFITS = [
  { title: "Live practice", text: "Interactive breakout rooms where you build real-world projects with expert instructors." },
  { title: "Onboarding setup", text: "A pre-workshop tool checklist so your software is ready before class starts." },
  { title: "Certificate + support", text: "Certificate of completion and a private WhatsApp technical support group." },
];

export const formatNaira = (kobo) => `₦${(kobo / 100).toLocaleString("en-NG")}`;
